import { render, staticRenderFns } from "./TopUpClients.vue?vue&type=template&id=5239189f&scoped=true&"
import script from "./TopUpClients.vue?vue&type=script&lang=js&"
export * from "./TopUpClients.vue?vue&type=script&lang=js&"
import style0 from "./TopUpClients.vue?vue&type=style&index=0&id=5239189f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5239189f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
